<p-select [readonly]="readonly()" [filter]="true" class="w-full" appendTo="body" [options]="options()" [(ngModel)]="value"></p-select>
